import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function EyeSlashIcon(props: IconProps) {
  return (
    <Icon width="20px" height="21px" viewBox="0 0 20 21" fill="none" {...props}>
      <Box as="g">
        <Box
          as="path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.055 15.546A8.6 8.6 0 0 1 10 17.299c-5.958 0-9.362-6.808-9.362-6.808a15.7 15.7 0 0 1 4.307-5.056m3.268-1.549A8 8 0 0 1 10 3.682c5.957 0 9.362 6.809 9.362 6.809a16 16 0 0 1-1.839 2.715m-5.719-.911a2.555 2.555 0 0 1-3.608.128 2.555 2.555 0 0 1-.128-3.609l.128-.128M.638 1.129l18.724 18.723"
        />
      </Box>
    </Icon>
  );
}
